export const APP_ROUTES = {
  home: "/",
  homePortal: "/home-portal",
  magicLink: "/magic-link",
  resetPassword: "/reset-password",
  admin: "/admin",
} as const;

/** Global Keycloak group that grants the read-only platform-admin dashboard. */
export const PLATFORM_ADMIN_GROUP = "pimo-home-portal-platform-admin";
/** Platform admins in this group may also delete apps (backend AppDeleterGuard). */
export const APP_DELETER_GROUP = "pimo-home-portal-app-deleter";

export const PRICING_PAGE_URL = "https://www.pimoapp.com/preise";
export const TERMS_OF_USE_URL = "https://pimo.com/terms";
export const PRIVACY_POLICY_URL = "https://pimo.com/privacy";

/** Contact email for Enterprise plan enquiries. */
export const ENTERPRISE_CONTACT_EMAIL = "contact@pimoapp.com";

/**
 * Support mailbox for anything the self-service portal deliberately does
 * not handle itself — currently downgrades (#2786/#2796) and, by the same
 * "contact support" convention, a scheduled cancellation an Owner wants to
 * reverse (no self-service "undo" in V1, per the #2785 UX spec answers:
 * https://gitlab.com/hipsquare/pimo/-/work_items/2785#note_3976958451).
 */
export const SUPPORT_EMAIL = "support@hipsquare.net";

/**
 * Machine-readable error code the backend attaches to a blocked downgrade
 * attempt (`SubscriptionsController.assertUpgradeOnly`, see
 * `subscription-errors.constants.ts` on `home-portal-backend`). The
 * frontend must branch on this code, never on the human-readable message,
 * so copy changes on either side can never silently break the "contact
 * support" UI.
 */
export const DOWNGRADE_BLOCKED_ERROR_CODE = "DOWNGRADE_BLOCKED";

/**
 * Machine-readable error code the backend attaches to an upgrade attempt
 * blocked because the subscription is already `cancel_scheduled`
 * (`SubscriptionsController.assertUpgradeOnly`, see
 * `subscription-errors.constants.ts` on `home-portal-backend`). Per the
 * #2785 resolved decisions ("cancel at period end, no self-service undo"),
 * an upgrade must not implicitly resume/clear a scheduled cancellation —
 * the frontend must branch on this code, never on the human-readable
 * message, so copy changes on either side can never silently break the
 * "contact support" UI.
 */
export const UPGRADE_BLOCKED_CANCELLATION_SCHEDULED_ERROR_CODE =
  "UPGRADE_BLOCKED_CANCELLATION_SCHEDULED";

/** Maximum number of users allowed when no plan has been selected. */
export const FREE_TIER_USER_LIMIT = 10;

/** Per-plan user limits – must stay in sync with the backend plans.constants.ts */
export const PLAN_USER_LIMITS: Record<string, number> = {
  basic: 20,
  advanced: 100,
  professional: 200,
};
